

export default function NoDisplayedLoading( props) {
  return <div className='NoDisplayedLoading' debug='NoDisplayedLoading' />;
}
